import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import AssessmentTempEditForm from './AssessmentTempEditForm';

const AssessmentTempEditContainer = ({ saveData, initialValues, ...rest }) => (
  <Formik
    initialValues={initialValues}
    onSubmit={(values, formikBag) => {
      const { resetForm } = formikBag;
      saveData(values);
      resetForm();
    }}
  >
    {() => <AssessmentTempEditForm {...rest} />}
  </Formik>
);

AssessmentTempEditContainer.propTypes = {
  saveData: PropTypes.func.isRequired,
  initialValues: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default AssessmentTempEditContainer;
